// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { Cart, updateCart } from "@insite/client-framework/Services/CartService";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";

export interface DropShipContactInfoParameter {
    dropShipContactInfo: string;
}

type HandlerType = ApiHandler<DropShipContactInfoParameter & HasOnSuccess, ServiceResult<Cart>>;

export const UpdateDropShipContactInfo: HandlerType = async props => {
    const { value: cart } = getCurrentCartState(props.getState());
    if (!cart) {
        throw new Error("The cart is not loaded. Try reloading the page.");
    }

    await updateCart({
        cart: {
            ...cart,
            properties: {
                ...cart.properties,
                dropShipContactInfo: props.parameter.dropShipContactInfo,
            },
        },
    });
};

export const LoadCart: HandlerType = props => {
    props.dispatch(loadCurrentCart());
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [UpdateDropShipContactInfo, LoadCart, ExecuteOnSuccessCallback];

const xDropShipContactInfo = createHandlerChainRunner(chain, "xDropShipContactInfo");

export default xDropShipContactInfo;
